import * as React from 'react';
import  './fileitem.scss';
import Moment from 'react-moment';
import { Modal,IDragOptions,} from 'office-ui-fabric-react/lib/Modal';
import { ContextualMenu } from 'office-ui-fabric-react/lib/ContextualMenu';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import { Helper } from '../../Utils/Helper';
export interface IProps{
    fileitem;
    IsRecent;
    GetThumbnailImage;
    GetFilePreview;
    SaveO2SFileInfo;
}
export default class FileItem extends React.Component<IProps> {
    public state ={load:0,showModal:false,showModalO2S:false};
    public _dragOptions: IDragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
      };
    public thumbnailurl=null;
    public _titleId: string =getId('title');
    public _subtitleId: string = getId('subText');
    public _titledIdO2S: string =getId('titleO2S');
    public _subtitleIdO2S: string = getId('subTextO2S');
    public o2surl='';
    public filetypelist={
        xml:'xml.png',
        zip:'zip.png',
        message:'Mail.png',
        sheet:'excel.png',
        document:'word.png',
        msonenote:'onenote.png',
        pdf:'pdf.png',
        presentation:'powerpoint.png',
        plain:'txt.png',
        video:'video.png',
        image:'image.png',
        audio:'audio.png',
        other:'unknown.png'
    };
    constructor(props) {
        super(props);
      }
    
    public render() {
        let name='';
        try{
            if(this.props.fileitem.lastShared && this.props.fileitem.resourceReference){
                return this.RenderAttachment();
            }
           
            //('recent=',this.props.IsRecent,this.props.fileitem);
            //let url=this.props.IsRecent?this.props.fileitem.webUrl:this.props.fileitem.remoteItem.webUrl;
            let url=this.props.fileitem.remoteItem.webUrl;
            // let name=this.props.IsRecent? this.props.fileitem.name:this.props.fileitem.lastShared.sharingSubject;
            // let name=this.props.IsRecent? this.props.fileitem.name:this.props.fileitem.resourceVisualization.title;
            name=this.props.fileitem.name;
            let createdateval=this.props.fileitem.fileSystemInfo.createdDateTime?this.props.fileitem.fileSystemInfo.createdDateTime:this.props.fileitem.fileSystemInfo.lastAccessedDateTime;
            let creator='';
            if(this.props.fileitem && this.props.fileitem.createdBy && this.props.fileitem.createdBy.user){
                creator=this.props.fileitem.createdBy.user.displayName;
            }
             
            
            let lastupdatedateval=this.props.IsRecent?this.props.fileitem.lastModifiedDateTime:this.props.fileitem.remoteItem.shared.sharedDateTime;
            let updatedby=this.props.IsRecent?this.props.fileitem.lastModifiedBy.user.displayName:
            this.props.fileitem.remoteItem.shared.sharedBy!=null? this.props.fileitem.remoteItem.shared.sharedBy.user.displayName:this.props.fileitem.createdBy.user.displayName;
            if(this.thumbnailurl==null){
                let thumbapi=`v1.0/sites/${this.props.fileitem.remoteItem.sharepointIds.siteId}/drives/${this.props.fileitem.remoteItem.parentReference.driveId}/items/${this.props.fileitem.remoteItem.id}/thumbnails/0/large/url`;
                this.LoadFilethumbnail(thumbapi);
            }
            //let previewapi=`v1.0/sites/${this.props.fileitem.remoteItem.sharepointIds.siteId}/drives/${this.props.fileitem.remoteItem.parentReference.driveId}/items/${this.props.fileitem.remoteItem.id}/preview`;
            let titleclass=this.props.IsRecent?'webpartTitle recenttitel':'webpartTitle sharedtittle';
            let mailurl=`mailto:?subject=${name}&body=${encodeURIComponent(url)}`;
            return (
            
                <div className='ms-Grid-col ms-sm12 ms-lg6'>
                    <div className='files'>  
                        <div className='webpart'>
                            <div className={titleclass}>
                                <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm10 ms-lg10'>
                                        <a href={url} target='_blank'><div className='filename textellips' title={name}>{name}</div></a>
                                    </div>
                                   {/*  <div className='ms-Grid-col ms-sm2 ms-lg2'>
                                        <i title='Show preview' onClick={()=>{this.LoadFilePreview(previewapi)}} style={{fontSize:'18px'}} className='ms-Icon ms-Icon--MiniExpand showfilepreview' />
                                    </div> */}
                                </div>
                            </div>
                            <div className='ms-Grid-row'>
                                    <div  className='ms-Grid-col ms-sm12 ms-lg12 imagecontainer'>
                                        {this.Getthmubimage(this.props.fileitem.remoteItem.file.mimeType)}
                                    </div>
                            </div>
                            <div className='ms-Grid-row'>
                                    <div className='ms-Grid-col ms-sm12 ms-lg12'>
                                        <div className='filleinfo textellips' title={creator}>
                                            <b>Create: </b><Moment format="DD MMM YY HH:mm">{createdateval}</Moment> by {creator}
                                        </div>
                                        <div className='filleinfo textellips' title={updatedby}>
                                            <b>Update: </b><Moment format="DD MMM YY HH:mm">{lastupdatedateval}</Moment> by {updatedby}
                                        </div>
                                    </div>
                            </div>
                                <div className='ms-Grid-row footer'>
                                    <div className='ms-Grid-col ms-sm12 ms-lg12'>
                                        <div className="r">
                                            <a href={mailurl} target="_blank"  title="Create an e-mail and share a link "><i className="ms-Icon ms-Icon--MailSolid" aria-hidden="true" /></a>
                                             {/* <img className='o2sicon' title='Save through O2S' onClick={()=>{this.OpenO2sModal('fileurl','itemid','source')}}  src={require(`../../Images/o2s.png`)} /> */}
                                        </div>
                                   
                                    </div>
                                   {/*  <div className='ms-Grid-col ms-sm6 ms-lg6 l'>
                                            <Moment format="DD MMM YY HH:mm">{dateval}</Moment>
                                    </div>
                                    <div className='ms-Grid-col ms-sm6 ms-lg6 r' title={actor}>
                                    {actor}
                                    </div> */}
                                </div>
                                </div>  
                            </div>
                            {this.GetModalUI(name)}
                            {this.GetO2SModal()}
                </div>
             
            );
        }
        catch(ex){
            return(<div className='files'>
                <div className='webpart'>
                    <span>{name}</span>
                </div>
            </div>);
        }
      }
      
      private RenderAttachment=()=>{
        let url=this.props.fileitem.resourceReference.webUrl;
        let mainitemurl=this.props.fileitem.lastShared.sharingReference.webUrl;
        let subject=this.props.fileitem.lastShared.sharingSubject;
        let name=Helper.getQueryStringParameter('AttachmentName',this.props.fileitem.resourceReference.webUrl);
        let dateval=this.props.fileitem.lastShared.sharedDateTime;
        let actor=this.props.fileitem.lastShared.sharedBy.displayName;
        if(name==''){
            name='Attachment';
        }
        return (
            <div className='ms-Grid-col ms-sm6'>
                <div className='files'>   
                    <div className='webpart'>
                    <div className='webpartTitle attachmenttitel'>
                        <div className='ms-Grid-row'>
                            <div className='ms-Grid-col ms-sm10 ms-lg10'>
                                <a href={url} target='_blank'><div className='filename textellips' title={name}>{name}</div></a>
                            </div>
                            <div className='ms-Grid-col ms-sm2 ms-lg2'>
                            <a title={'Open in browser '+ subject} href={mainitemurl} target='_blank'><i style={{fontSize:'18px'}} className='ms-Icon ms-Icon--MiniExpand showfilepreview' /> </a>
                            </div>
                        </div>
                    </div>
                    <div className='ms-Grid-row'>
                        <div  className='ms-Grid-col ms-sm12 ms-lg12 imagecontainer'>
                            {this.Getthmubimage(this.props.fileitem.resourceVisualization.mediaType)}
                        </div>
                    </div>
                    <div className='ms-Grid-row'>
                        <div className='ms-Grid-col ms-sm12 ms-lg12'>
                            <div className='filleinfo textellips' title={actor}>
                                <b>Shared: </b><Moment format="DD MMM YY HH:mm">{dateval}</Moment> by {actor}
                            </div>
                            <div className='filleinfo textellips'>
                                <b>Type: </b> <span className='cap'>{this.props.fileitem.lastShared.sharingReference.type.replace('microsoft.graph.','')}</span>
                            </div>
                        </div>
                    </div>
                    <div className='ms-Grid-row footer'>
                                <div className='ms-Grid-col ms-sm12 ms-lg12'>
                                    {/* <div className="r">
                                         <img className='o2sicon' title='Save through O2S' onClick={()=>{this.OpenO2sModal('fileurl','itemid','source')}}  src={require(`../../Images/o2s.png`)} />
                                    </div> */}
                               
                                </div>
                       {/*  <div className='ms-Grid-col ms-sm6 ms-lg6'>
                            &nbsp;
                        </div> */}
                       {/*  <div className='ms-Grid-col ms-sm6 ms-lg6 l'>
                                <Moment format="DD MMM YY HH:mm">{dateval}</Moment>
                        </div>
                        <div className='ms-Grid-col ms-sm6 ms-lg6 r' title={actor}>
                        {actor}
                        </div> */}
                    </div>
                    </div> 
                </div>
                {this.GetModalUI(name)}
                {this.GetO2SModal()}
            </div>
         
        );
      }
      private Getthmubimage=(mimeType:string)=>{
          
          if(this.thumbnailurl!=null && this.thumbnailurl!=''){
            return <img onClick={this._showModal} className='boxwithshadow' src={this.thumbnailurl} />
          } else{
              let imageurl='unknown.png';
              let parts=mimeType.toLowerCase().split('/');
              if(this.filetypelist[parts[0]]!=null){
                imageurl=this.filetypelist[parts[0]];
              } else if(this.filetypelist[parts[1]]!=null){
                imageurl=this.filetypelist[parts[1]];
              } else if(parts[1].indexOf('.')>=0){
                parts=parts[1].split('.');
                if(this.filetypelist[parts[parts.length-1]]!=null){
                    imageurl=this.filetypelist[parts[parts.length-1]];
                }
              }
              return <img className='boxwithshadow'  src={require(`../../Images/${imageurl}`)} />
          }
      }
      private LoadFilethumbnail=(apiurl)=>{
        let fnsuccess=(result)=>{
            this.thumbnailurl=result.data.value!=null?result.data.value:'';
            if(this.thumbnailurl!=null && this.thumbnailurl!=''){
                this.setState({load:1});
            }
        } 
        this.props.GetThumbnailImage(apiurl,fnsuccess);
      }
    //   private LoadFilePreview=(apiurl)=>{
    //     /* let fnsuccess=(result)=>{
    //         debugger
    //     }; */
    //     //this.props.GetFilePreview(apiurl,fnsuccess);
    //   }
     /*  private OpenO2sModal=(fileurl,itemid,filesource)=>{
        this.o2surl='';
        this._showO2SModal();
      } */
      private GetO2SModal=()=>{
        return (
            <Modal
                titleAriaId={this._titledIdO2S}
                subtitleAriaId={this._subtitleIdO2S}
                isOpen={this.state.showModalO2S}
                onDismiss={this._closeO2SModal}
                isBlocking={false}
                containerClassName="O2smodalcontainer"
                dragOptions={this._dragOptions}>
                <div className="modalheader">
                <span id={this._titleId}>Save to Sharepoint</span>
                <span className="modalclose" onClick={this._closeO2SModal}>X</span>
                </div>
                <div id={this._subtitleIdO2S} className="modalbody o2swindow">
                    <iframe src={this.o2surl} style={{width:'98%',height:'78vh'}} />
                </div>
            </Modal>
          );
      }

      private GetModalUI=(name)=>{
          return (
            <Modal
                titleAriaId={this._titleId}
                subtitleAriaId={this._subtitleId}
                isOpen={this.state.showModal}
                onDismiss={this._closeModal}
                isBlocking={false}
                containerClassName="modalcontainer"
                dragOptions={this._dragOptions}>
                <div className="modalheader">
                <span id={this._titleId}>{name}</span>
                <span className="modalclose" onClick={this._closeModal}>X</span>
                </div>
                <div id={this._subtitleId} className="modalbody imagepreview">
                    <img className='shadowonly' src={this.thumbnailurl} />
                </div>
            </Modal>
          );
      }
      private _showModal = (): void => {
          if(this.thumbnailurl!=null && this.thumbnailurl!=''){
            this.setState({ showModal: true });
          }
      }
    
      private _closeModal = (): void => {
        this.setState({ showModal: false });
      }

     /*  private _showO2SModal = (): void => {
        // recent=true this.props.fileitem.remoteItem.webDavUrl,this.props.fileitem.remoteItem.name,this.props.fileitem.remoteItem.sharepointIds.siteUrl
        // recent=false this.props.fileitem.
        var filename='',mainutemid='',fileitemid='',fileurl='',filesource='',siteurl='';
        if(this.props.fileitem.lastShared && this.props.fileitem.resourceReference){
            if(this.props.fileitem.lastShared.sharingReference.type=="microsoft.graph.event"){
                filesource='event';
            }
            else{
                filesource='mail';//this.props.fileitem.resourceVisualization.containerDisplayName
            }
            fileurl=this.props.fileitem.resourceReference.webUrl;
            filename=Helper.getQueryStringParameter('AttachmentName',fileurl);
            mainutemid=Helper.getQueryStringParameter('ItemId',fileurl);
            fileitemid=Helper.getQueryStringParameter('AttachmentId',fileurl);
            
        } else{
            filename=this.props.fileitem.remoteItem.name;
            fileurl=this.props.fileitem.remoteItem.webDavUrl;
            siteurl=this.props.fileitem.remoteItem.sharepointIds.siteUrl;
            filesource='Sharepoint';
        }
        var fileinfo={
            Id:Helper.newguid(),
            UserEmail:'',
            MainItemId:mainutemid,
            FileIemId:fileitemid,
            FileUrl:fileurl,
            FileSource:filesource,
            FileName:filename,
            SiteURL:siteurl
        };
        this.o2surl='';
        this.props.SaveO2SFileInfo(fileinfo,
                                   (response,modalurl,email)=>{
                                    if(response.data.IsSuccess){
                                        this.o2surl=`${modalurl}?from=mipateam&useremail=${email}&requestid=${fileinfo.Id}`;
                                        this.setState({ showModalO2S: true });
                                    }
                                    
                                    },
                                   (error)=>{
                                        console.error(error);
                                    });
        
    } */
  
    private _closeO2SModal = (): void => {
      this.setState({ showModalO2S: false });
    }
}